import { ExportsTable } from "./data-table";
import { ExportsTableInstanceProvider } from "./table-instance-provider";

type Props = {
  data: any;
};

export const ExportsComponent = ({ data }: Props) => {
  return (
    <ExportsTableInstanceProvider tableName="settings.exports" data={data}>
      <ExportsTable />
    </ExportsTableInstanceProvider>
  );
};
